<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">     
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item style="width:30%">
          	  <el-date-picker v-model="query.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :unlink-panels="false" style="width:100%"></el-date-picker>
          </el-form-item>
          <el-form-item style="width:18%">
              <el-input placeholder="请输入关键字" v-model="query.key" clearable @keyup.enter.native="getlists" @change="changesearch" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getdrawslists">查询</el-button>
              <el-button type="danger" icon="el-icon-plus" @click="add">发布活动</el-button>
              <el-button type="warning" icon="el-icon-view" @click="getaward">中奖纪录</el-button>
              <el-button type="primary" icon="el-icon-view" @click="getpacketfund">中奖红包提现流水</el-button>
          </el-form-item>   
      </el-form>

      <el-tag type="danger" style="margin-top:10px">温馨提示：活动进行时修改活动信息需谨慎，有可能会造成奖品数据丢失</el-tag>
      
      <div class="backborder2" style="margin-top:10px">
	        <el-table :data="lists" v-loading="listsloading">
	          <el-table-column prop="name" label="活动名称"></el-table-column>
            <el-table-column prop="time" label="活动时间" width="180" align="center"></el-table-column>
            <el-table-column prop="amount" label="抽奖条件（满足下单金额）" width="120" align="center"></el-table-column>
            <el-table-column prop="isadd" label="是否累加" width="120" align="center"></el-table-column>
            <el-table-column prop="inputtime" label="添加时间" width="160" align="center"></el-table-column>
            <el-table-column prop="managername" label="添加人" width="120" align="center"></el-table-column>
            <el-table-column prop="status" label="活动状态" width="120" align="center">
                <template slot-scope="scope">
                    <el-tag type="info" v-if="scope.row.status==1">未开始</el-tag>
                    <el-tag type="danger" v-if="scope.row.status==2">进行中...</el-tag>
                    <el-tag type="info" v-if="scope.row.status==3">已结束...</el-tag>
                </template>
            </el-table-column>
	          <el-table-column label="操作" width="150" align="center">
		            <template slot-scope="scope">
                        <el-button type="primary" size="small" circle icon="el-icon-view" @click="drawsCurrent(scope.row)"></el-button>
		                <el-button type="warning" size="small" circle icon="el-icon-edit" @click="editCurrent(scope.row)"></el-button>
		                <el-button type="danger" size="small" circle icon="el-icon-delete" @click="delCurrent(scope.row)"></el-button>
		            </template>
	          </el-table-column>
          </el-table>

          <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="drawspageChange"
	            @current-change="drawspageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="rows">
	          </el-pagination>
	          <!--分页end-->
          </div>
      </div>
          
      <el-dialog title="活动详情" :visible.sync="drawinfoDialog" width="65%" top="5vh">
          <!-- 基本信息 -->
          <el-col :span="24" style="padding-bottom:.3rem;padding:0 2% 0 2%;border-bottom:1px solid rgb(221,221,221,.2)"><span>基本信息</span></el-col>
          <el-col :span="24" style="background:rgb(221,221,221,.2);border-radius:5px;padding:0 2% .5rem 2%">
          <el-col :span="24" style="margin-top:10px">活动名称：{{drawsinfos.name}}</el-col>
          <el-col :span="24">活动时间：{{drawsinfos.showdate}}</el-col>
          <el-col :span="24">活动规则：{{drawsinfos.value}}</el-col>
          <el-col :span="24">抽奖次数是否可以叠加：{{drawsinfos.isadd==1 ? '是' : '否'}}</el-col>
          <el-col :span="24">设置一次活动需要达到的抽奖金额：{{drawsinfos.amount}}</el-col>
          <el-col :span="24">设置一次活动能设置的最大奖个数：{{drawsinfos.limit}}</el-col>
          </el-col>

          <!-- 统计数据 -->
          <el-col :span="24" style="padding-bottom:.3rem;margin-top:10px;padding:0 2% 0 2%;border-bottom:1px solid rgb(221,221,221,.2)"><span>统计信息</span></el-col>
          <el-col :span="24" style="border-radius:5px;padding:.5rem 2% .5rem 2%;background:rgb(221,221,221,.2);">
              <el-col :span="5">下单次数：{{drawsinfos.ordernums}}</el-col>
              <el-col :span="5">抽奖次数：{{drawsinfos.nums}}</el-col>
              <el-col :span="5">使用率：{{drawsinfos.percent}}</el-col>
          </el-col>

          <!-- 奖品设置 -->
          <el-col :span="24" style="margin:50px 0 20px 0;">
              <el-table :data="drawsinfos.lists">
	            <el-table-column label="奖品图片" width="180">
                    <template slot-scope="scope">
                        <img :src="scope.row.showimg" style="width:70%;border-radius:5px;border:1px solid rgb(221,221,221,.7)" />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="奖品名称"></el-table-column>
                <el-table-column prop="typename" label="奖品类型" width="120" align="center"></el-table-column>
                <el-table-column prop="numbers" label="抽中次数" width="120" align="center"></el-table-column>
                <el-table-column prop="percent" label="抽中概率（100%）" width="150" align="center"></el-table-column>
              </el-table>
          </el-col>

          <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="drawinfoDialog = false">取 消</el-button>
          </div>
      </el-dialog>
      
          
  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Draws/index",
      transitionshow:true,
      query: {
          act:'lists',
          token:this.$cookies.get('token'),
          date:[],
          key:'',
          p:1,
          rollpage:10
      },
      ischange:false,
      lists:[],
      rows:0,
      listsloading:false,
      drawsinfos:[],
      drawinfoDialog:false,
      
    }  
  },
  mounted(){
     this.getdrawslists();
  },
  methods:{

      /** 获取活动信息 **/
      getdrawslists() {
          if(this.ischange==true) {this.query.p=1;this.query.rollpage=10;}
          this.listsloading=true;
          var resource = this.$resource(this.url);
          resource.query(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.listsloading=false;
              }else{
                  this.lists = JSON.parse(Base64.decode(res.data.Data));
	              this.rows=parseInt(res.data.count);
                  if(this.ischange==true) this.ischange=false;
                  this.listsloading=false;
              }
          }).catch((res) => {
              this.listsloading=false;
          });
      },

      drawspageChange(val) {
        this.query.rollpage = val;
        this.getdrawslists();
      },
      drawspageCurrentChange(val) {
        this.query.p = val;
        this.getdrawslists();
      },
      
      /** 新增抽奖活动信息 **/
      add() {
          this.$emit('listenchild',{name:'新增抽奖活动',url:'Drawsadd'});
      },  

      /** 编辑抽奖活动信息 **/
      editCurrent(item) {
          this.$emit('listenchild',{name:'编辑抽奖活动',url:'Drawsedit',data:item});
      },

      /** 获取中奖纪录信息 **/
      getaward() {
          this.$emit('listenchild',{name:'中奖纪录信息',url:'Award'});
      },

      /** 获取中奖红包提现记录 **/
      getpacketfund() {
          this.$emit('listenchild',{name:'中奖红包提现流水',url:'Packetfund'});
      },


      /** 获取活动详情信息 **/
      drawsCurrent(item) {
          var resource = this.$resource(this.url);
	      resource.query({act:'getdrawsinfo',id:item.id,token:this.$cookies.get('token')}).then((res) => {
		      if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
		      }else{
                  this.drawinfoDialog=true;
		          var result = JSON.parse(Base64.decode(res.data.Data));
                  var _this=this;
                  result.lists.forEach(function(item,i) {
                      result.lists[i].type=Number(item.type);
                  });
                  this.drawsinfos=result;
                  this.drawsinfos.showdate=result.date[0]+' ~ '+result.date[1];
		      }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
      },


      /** 删除活动信息 **/
      delCurrent(item) {
          this.$confirm('您是否需要删除活动： ' + item.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
        	  // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'deldraws',id:item.id,token:this.$cookies.get('token')}).then((res) => {
            	    if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                  }else{
                      this.$message.success('删除广告：' + item.name + '成功!');
                      this.getdrawslists();
                  }
              }).catch((res) => {
            	    this.$message.error(this.GLOBAL.errortext);
              });
          }).catch(() => {
        	
          });
      },

  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/Draws.vue